import { render, staticRenderFns } from "./callData.vue?vue&type=template&id=2b5b0344&"
import script from "./callData.vue?vue&type=script&lang=js&"
export * from "./callData.vue?vue&type=script&lang=js&"
import style0 from "./callData.vue?vue&type=style&index=0&id=2b5b0344&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports